import { useState } from "react";
import MainLayout from "../../layout/MainLayout";
import { ToggleButton } from "../index";
import CreditDetails from "./CreditDetails";
import CreditReportOverview from "./CreditReportOverview";
import FactorImpactingScore from "./FactorImpactingScore";
import QuickActionSelect from "../quick-action-select/QuickActionSelect";
const componentForTab = (tab) => {
  switch (tab) {
    case "Factors Impacting Score":
      return <FactorImpactingScore />;
    case "Credit report Overview":
      return <CreditReportOverview />;
    case "Credit Details":
    default:
      return <CreditDetails />;
  }
};

const Credit = ({ initialTab = "Credit Details" }) => {
  const [selectedComponent, setSelectedComponent] = useState(
    componentForTab(initialTab)
  );

  const onToggle = (value) => {
    switch (value) {
      case "Credit Details":
        setSelectedComponent(<CreditDetails />);
        break;
      case "Factors Impacting Score":
        setSelectedComponent(<FactorImpactingScore />);
        break;
      case "Credit report Overview":
        setSelectedComponent(<CreditReportOverview />);
        break;
      default:
        setSelectedComponent(<CreditDetails />);
    }
  };
  return (
    <>
      <MainLayout NavName="Credit" expand={false}>
        <div>
          <div className="container mt-5">
            <div className="d-flex justify-content-md-between align-items-center flex-wrap gap-3 justify-content-center">
              <div className="w-75">
                <ToggleButton
                  options={[
                    "Credit Details",
                    "Factors Impacting Score",
                    "Credit report Overview",
                  ]}
                  defaultValue={initialTab}
                  onChange={(value) => onToggle(value)}
                  block={true}
                />
              </div>
              <QuickActionSelect />
            </div>

            {selectedComponent}
          </div>
        </div>
      </MainLayout>
    </>
  );
};

export default Credit;
